<template>
    <div>
        <div class="pdf-box">
            <pdf :src="pdfSrc" :page="currentPage"   @num-pages="pageCount=$event"
            @page-loaded="currentPage=$event"></pdf>
        </div>
        <p class="arrow">
            <!-- // 上一页 -->
            <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</span>
            {{currentPage}} / {{pageCount}}
            <!-- // 下一页 -->
            <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</span>
        </p>
    </div>
</template>
<script>
    import pdf from 'vue-pdf'
    export default {
        metaInfo: {
            meta: [
                { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
            ]
        },
        props: ['pdfSrc'],
        components: {
            pdf
        },
        data() {
            return {
                // pdfSrc: this.pdfSrc, // pdf文件地址
                // numPages: undefined,
                currentPage: 1, // pdf文件页码
                pageCount: 0, // pdf文件总页数
            }
        },
        mounted() {
            
        },
        methods: {
            changePdfPage(val) {
                // console.log(val)
                if (val === 0 && this.currentPage > 1) {
                    this.currentPage--
                    // console.log(this.currentPage)
                }
                if (val === 1 && this.currentPage < this.pageCount) {
                    this.currentPage++
                    // console.log(this.currentPage)
                }
            }
        }


    }
</script>
<style scoped>
    .pdf-box {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        max-width: 1024px;
        width: 100%;
        margin: 0 auto;
        overflow-x: hidden;
        height: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        font-size: .28rem;

    }
    .arrow{
        text-align: center;
        font-size: 0.16rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/pdf.vue